import { css } from '@emotion/core';
import { aTag, media, tokens } from '@domain-group/fe-brary';
import { designTokenFonts, truncateLines } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors,
  spacing = tokens.spacing;
export var card = /*#__PURE__*/css("display:flex;flex-direction:column;color:", colors.neutral.heavy.default, ";text-decoration:none;align-items:stretch;margin-bottom:", spacing.l, ";background:", colors.neutral.surface.default, ";border:1px solid ", colors.neutral.trim.default, ";border-radius:5px;", media('>=tablet'), "{flex-direction:row;}");
export var cardHeroAndLogo = /*#__PURE__*/css("display:flex;flex-direction:column;min-height:180px;max-height:180px;", media('>=tablet'), "{flex:0 0 200px;}");
export var cardHero = /*#__PURE__*/css("background-size:cover;background-repeat:no-repeat;background-position:center;height:132px;", media('>=tablet'), "{height:100%;}");
export var developer = logoBackgroundColour => /*#__PURE__*/css("min-height:48px;max-height:48px;background:", logoBackgroundColour, ";");
export var developerLogo = {
  name: "dpucvm",
  styles: "height:48px;padding:4px 8px;"
};
export var cardText = /*#__PURE__*/css("padding:", spacing.m, ";flex-grow:1;", media('>=desktop'), "{padding:24px;}");
export var cardName = /*#__PURE__*/css(designTokenFonts.displaySmall);
export var cardDescription = /*#__PURE__*/css(designTokenFonts.body, " ", truncateLines(3));
export var cardLink = /*#__PURE__*/css(aTag, ";", designTokenFonts.caption, " display:flex;gap:5px;margin-top:19px;");
export var cardLinkIcon = {
  name: "18eau0h",
  styles: "height:18px;width:18px;"
};
export var otherListingsHeading = /*#__PURE__*/css(designTokenFonts.subheading, " margin-bottom:8px;color:", colors.neutral.heavy.default, ";");